import { createFileRoute } from '@tanstack/react-router';

import { coinPackagesQueryOptions } from '@/features/coins/api';
import { CoinShopPage } from '@/features/coins/components/coin-shop-page';
import { coinSelectionSearchSchema } from '@/features/coins/selection';

export const Route = createFileRoute('/_app/')({
  validateSearch: coinSelectionSearchSchema,
  staticData: { title: '코인 충전' },
  loader: ({ context }) =>
    context.queryClient.query({ ...coinPackagesQueryOptions(), staleTime: 'static' }),
  component: CoinShopRoute,
});

function CoinShopRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CoinShopPage
      search={search}
      onSelect={next => {
        void navigate({ search: next, replace: true, resetScroll: false });
      }}
    />
  );
}
